import { render, staticRenderFns } from "./TrivestButton.vue?vue&type=template&id=e5340218&scoped=true"
import script from "./TrivestButton.vue?vue&type=script&lang=ts"
export * from "./TrivestButton.vue?vue&type=script&lang=ts"
import style0 from "./TrivestButton.vue?vue&type=style&index=0&id=e5340218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5340218",
  null
  
)

export default component.exports